import _slicedToArray from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Card/card';
import { css } from '@patternfly/react-styles';
import { useOUIAProps } from '../../helpers';
export var CardContext = React.createContext({
  cardId: '',
  registerTitleId: function registerTitleId() {},
  isExpanded: false
});
export var Card = function Card(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'article' : _a$component,
      _a$isHoverable = _a.isHoverable,
      isHoverable = _a$isHoverable === void 0 ? false : _a$isHoverable,
      _a$isCompact = _a.isCompact,
      isCompact = _a$isCompact === void 0 ? false : _a$isCompact,
      _a$isSelectable = _a.isSelectable,
      isSelectable = _a$isSelectable === void 0 ? false : _a$isSelectable,
      _a$isSelectableRaised = _a.isSelectableRaised,
      isSelectableRaised = _a$isSelectableRaised === void 0 ? false : _a$isSelectableRaised,
      _a$isSelected = _a.isSelected,
      isSelected = _a$isSelected === void 0 ? false : _a$isSelected,
      _a$isDisabledRaised = _a.isDisabledRaised,
      isDisabledRaised = _a$isDisabledRaised === void 0 ? false : _a$isDisabledRaised,
      _a$isFlat = _a.isFlat,
      isFlat = _a$isFlat === void 0 ? false : _a$isFlat,
      _a$isExpanded = _a.isExpanded,
      isExpanded = _a$isExpanded === void 0 ? false : _a$isExpanded,
      _a$isRounded = _a.isRounded,
      isRounded = _a$isRounded === void 0 ? false : _a$isRounded,
      _a$isLarge = _a.isLarge,
      isLarge = _a$isLarge === void 0 ? false : _a$isLarge,
      _a$isFullHeight = _a.isFullHeight,
      isFullHeight = _a$isFullHeight === void 0 ? false : _a$isFullHeight,
      _a$isPlain = _a.isPlain,
      isPlain = _a$isPlain === void 0 ? false : _a$isPlain,
      ouiaId = _a.ouiaId,
      _a$ouiaSafe = _a.ouiaSafe,
      ouiaSafe = _a$ouiaSafe === void 0 ? true : _a$ouiaSafe,
      _a$hasSelectableInput = _a.hasSelectableInput,
      hasSelectableInput = _a$hasSelectableInput === void 0 ? false : _a$hasSelectableInput,
      selectableInputAriaLabel = _a.selectableInputAriaLabel,
      _a$onSelectableInputC = _a.onSelectableInputChange,
      onSelectableInputChange = _a$onSelectableInputC === void 0 ? function () {} : _a$onSelectableInputC,
      props = __rest(_a, ["children", "id", "className", "component", "isHoverable", "isCompact", "isSelectable", "isSelectableRaised", "isSelected", "isDisabledRaised", "isFlat", "isExpanded", "isRounded", "isLarge", "isFullHeight", "isPlain", "ouiaId", "ouiaSafe", "hasSelectableInput", "selectableInputAriaLabel", "onSelectableInputChange"]);

  var Component = component;
  var ouiaProps = useOUIAProps(Card.displayName, ouiaId, ouiaSafe);

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      titleId = _React$useState2[0],
      setTitleId = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      ariaProps = _React$useState4[0],
      setAriaProps = _React$useState4[1];

  if (isCompact && isLarge) {
    // eslint-disable-next-line no-console
    console.warn('Card: Cannot use isCompact with isLarge. Defaulting to isCompact');
    isLarge = false;
  }

  var getSelectableModifiers = function getSelectableModifiers() {
    if (isDisabledRaised) {
      return css(styles.modifiers.nonSelectableRaised);
    }

    if (isSelectableRaised) {
      return css(styles.modifiers.selectableRaised, isSelected && styles.modifiers.selectedRaised);
    }

    if (isSelectable || isHoverable) {
      return css(styles.modifiers.selectable, isSelected && styles.modifiers.selected);
    }

    return '';
  };

  var containsCardTitleChildRef = React.useRef(false);

  var registerTitleId = function registerTitleId(id) {
    setTitleId(id);
    containsCardTitleChildRef.current = !!id;
  };

  React.useEffect(function () {
    if (selectableInputAriaLabel) {
      setAriaProps({
        'aria-label': selectableInputAriaLabel
      });
    } else if (titleId) {
      setAriaProps({
        'aria-labelledby': titleId
      });
    } else if (hasSelectableInput && !containsCardTitleChildRef.current) {
      setAriaProps({}); // eslint-disable-next-line no-console

      console.warn('If no CardTitle component is passed as a child of Card the selectableInputAriaLabel prop must be passed');
    }
  }, [hasSelectableInput, selectableInputAriaLabel, titleId]);
  return React.createElement(CardContext.Provider, {
    value: {
      cardId: id,
      registerTitleId: registerTitleId,
      isExpanded: isExpanded
    }
  }, hasSelectableInput && React.createElement("input", Object.assign({
    className: "pf-screen-reader",
    id: "".concat(id, "-input")
  }, ariaProps, {
    type: "checkbox",
    checked: isSelected,
    onChange: function onChange(event) {
      return onSelectableInputChange(id, event);
    },
    disabled: isDisabledRaised,
    tabIndex: -1
  })), React.createElement(Component, Object.assign({
    id: id,
    className: css(styles.card, isCompact && styles.modifiers.compact, isExpanded && styles.modifiers.expanded, isFlat && styles.modifiers.flat, isRounded && styles.modifiers.rounded, isLarge && styles.modifiers.displayLg, isFullHeight && styles.modifiers.fullHeight, isPlain && styles.modifiers.plain, getSelectableModifiers(), className),
    tabIndex: isSelectable || isSelectableRaised ? '0' : undefined
  }, props, ouiaProps), children));
};
Card.displayName = 'Card';